<template>
  <div class="sp-template plate-template order-plate-template">
    <div class="h-title">订单详情</div>
    <el-card class="box-card">
      <!-- 基本信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">基本信息</span>

          <span style="float: right;">
            <el-button size="mini" @click="$router.go(-1)">返 回</el-button>
          </span>
        </div>
        <div class="plate-content__main">
          <div class="list-items">
            <div class="item">
              <div class="label">订&nbsp;&nbsp;单&nbsp;&nbsp;号</div>
              <div class="text">{{orderForm.id}}</div>
            </div>
            <div class="item">
              <div class="label">一般贸易</div>
              <div class="text">{{orderForm.generalTrade ? "是":"否"}}</div>
            </div>
            <div class="item">
              <div class="label">客　　户</div>
              <div class="text">{{orderForm.customerName}}</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">总&nbsp;&nbsp;箱&nbsp;&nbsp;数</div>
              <div class="text">{{totalPcs}}</div>
            </div>
            <div class="item">
              <div class="label">总&nbsp;&nbsp;件&nbsp;&nbsp;数</div>
              <div class="text">{{totalQty}}</div>
            </div>
            <div class="item">
              <div class="label">产　　品</div>
              <div class="text">{{orderForm.productName}}</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">总&nbsp;&nbsp;体&nbsp;&nbsp;积</div>
              <div class="text">{{toFixed(actuallyTotalVolume,6)}} cbm</div>
            </div>
            <div class="item">
              <div class="label">总&nbsp;&nbsp;重&nbsp;&nbsp;量</div>
              <div class="text">{{toFixed(actuallyTotalWeight,4)}} kg</div>
            </div>
            <div class="item">
              <div class="label">下单时间</div>
              <div class="text">{{new Date(orderForm.createAt).toLocaleString()}}</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">取件方式</div>
              <div class="text">{{orderForm.deliveryTypeName}}</div>
            </div>
            <div class="item">
              <div class="label">附　　件</div>
              <div class="text">
                <a @click.prevent="downloadAttachment(orderForm.id,orderForm.detainGoods,orderForm.nonSysException)"
                  href ="#" class="download-icon">附件下载
                </a>
                <a @click.prevent="downloadCustomsDocuments(orderForm.id)"
                  href ="#" class="download-icon">报关文件下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 进度跟踪 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">进度跟踪</span>
        </div>
        <div class="plate-content__main">
          <el-steps :active="active" finish-status="success">
            <el-step v-for="(d,i) in orderForm.taskStages" :key="i" :title="d.stageName"></el-step>
          </el-steps>
          <div class="step-container">
            <div class="step-container__title">
              <span class="title">订单轨迹详情</span>
              <a href="#" v-if="in_configs(322)" @click.prevent="addTrackingInfoPop()" title="点击添加进度" class="el-icon-circle-plus-outline download-icon__blue"></a>

              <el-button v-if="in_configs(337)" type="info" size="mini" @click="sellerTrackingInfoPop()" style="margin-left:30px;">查看客户端轨迹</el-button>
            </div>
            <div class="step-container__content">
              <el-table 
                :data="trackingRecordArray" 
                v-show="trackingRecordArray && trackingRecordArray.length > 0"
                border 
                class="tracking-record__table" 
                style="width: 1000px;">
                <el-table-column label="订单轨迹记录">
                  <template slot-scope="scope">
                    <div class="record" :class="[scope.row.warning ? 'warning' : '']">{{scope.row.eventName}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="详情">
                  <template slot-scope="scope">
                    <div class="record" :class="[scope.row.warning ? 'warning' : '']">
                      <div class="detail">{{scope.row.content}}</div>
                      <el-tooltip class="item" effect="dark" content="点击查看详情" placement="top-start">
                        <a href="#" class="el-icon-search" v-show="scope.row.attach" @click.prevent="showDetial(scope.row.attach)"></a>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="时间" width="180">
                  <template slot-scope="scope">
                    <div class="record" :class="[scope.row.warning ? 'warning' : '']">{{scope.row.eventAt}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="step-container" v-show="batchTrackList && batchTrackList.length > 0">
            <div class="step-container__title">
              <span class="title">批次轨迹详情</span>
            </div>
            <div class="step-container__content">
              <el-table 
                :data="batchTrackList" 
                border 
                class="tracking-record__table" 
                style="width: 1000px;">
                <el-table-column label="批次轨迹" width="200">
                  <template slot-scope="scope">
                    <div class="record" >批次[{{scope.row.batchId}}]</div>
                  </template>
                </el-table-column>
                <el-table-column label="详情">
                  <template slot-scope="scope">
                    <div class="record" >
                      <div class="detail" v-html="scope.row.content"></div>
                      <el-tooltip class="item" effect="dark" content="点击查看详情" placement="top-start">
                        <a href="#" class="el-icon-search" v-show="scope.row.attach" @click.prevent="showDetial(scope.row.attach)"></a>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="计划时间" width="180">
                  <template slot-scope="scope">
                    <div class="record" >{{scope.row.time}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际时间" width="180">
                  <template slot-scope="scope">
                    <div class="record" >{{scope.row.innerTime}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" width="200">
                  <template slot-scope="scope">
                    <div class="record" >{{scope.row.remark}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="step-container" v-show="trackingNoArray && trackingNoArray.length > 0" >
            <div class="step-container__title">
              <span class="title">转单号详情</span>
            </div>
            <div class="step-container__content">
              <table 
                class="el-table tracking-number__table" 
                style="width: 1000px;">
                <thead>
                  <tr>
                    <th></th>
                    <th width="180">转单号</th>
                    <th>订单轨迹记录</th>
                    <th width="180">时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in trackingNoArray" :key="index">
                    <td>
                      <a href="#" 
                        v-show="item.details && item.details.length > 1"
                        :class="[item.collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down']" 
                        @click.prevent="item.collapsed = !item.collapsed">
                      </a>
                    </td>
                    <td width="180">{{item.trackingNo}}</td>
                    <td>
                      <div 
                        class="item" 
                        :class="[item.details[0].warning ? 'warning' : '']" 
                        v-if="item.collapsed">
                        {{item.details[0].eventName}}
                      </div>
                      <div v-else>
                        <div 
                          class="item" 
                          :class="[item.warning ? 'warning' : '']"
                          v-for="(detail, idx) in item.details" 
                          :key="idx">
                          {{detail.eventName}}
                        </div>
                      </div>
                    </td>
                    <td width="180">
                      <div 
                        class="item" 
                        :class="[item.details[0].warning ? 'warning' : '']" 
                        v-if="item.collapsed">
                        {{item.details[0].eventAt}}
                      </div>
                      <div v-else>
                        <div 
                          class="item" 
                          :class="[item.warning ? 'warning' : '']"
                          v-for="(detail, idx) in item.details" 
                          :key="idx">
                          {{detail.eventAt}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          </div>
      </div>
      <!-- 订单信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">订单信息</span>
        </div>
        <div class="plate-content__main">
          <div class="list-items">
            <div class="item">
              <div class="label">客户单号</div>
              <div class="text" v-if="orderForm.customerRefnumber">{{orderForm.customerRefnumber.customerOrderNumber}}</div>
            </div>
            <div class="item">
              <div class="label">公司名称</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.companyName}}
              </div>
            </div>
            <div class="item">
              <div class="label">FBA仓码</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.fbaWarehouseCode}}</div>
            </div>
            <div class="item">
              <div class="label">FBA号</div>
              <div class="text" v-if="orderForm.customerRefnumber">{{orderForm.customerRefnumber.fbaNumber}}</div>
            </div>
          </div>
          {{orderForm.shippingDetail.contractDetail}}
          <div class="list-items">
            <div class="item">
              <div class="label">联&nbsp;&nbsp;系&nbsp;&nbsp;人</div>
              <div class="text">{{orderForm.shippingDetail.contractDatail.name}}</div>
            </div>
            <div class="item">
              <div class="label">联系电话</div>
              <div class="text">{{orderForm.shippingDetail.contractDatail.phone}}</div>
            </div>
            <div class="item">
              <div class="label">国　　家</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.country}}
              </div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">州　　省</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.province}}
              </div>
            </div>
            <div class="item">
              <div class="label">城　　市</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.city}}
              </div>
            </div>
            <div class="item">
              <div class="label">邮　　编</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.zipcode}}
              </div>
            </div>
             <div class="item">
              <div class="label">Amazon Ref Id</div>
              <div class="text" v-if="orderForm.amazonReferenceId && orderForm.amazonReferenceId">
                {{orderForm.amazonReferenceId}}
              </div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">详细地址1</div>
              <div class="text" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address">
                {{orderForm.shippingDetail.address.address}}
              </div>
            </div>
          </div>
          <div class="list-items" v-if="orderForm.shippingDetail && orderForm.shippingDetail.address && orderForm.shippingDetail.address.address2 !== ''">
            <div class="item">
              <div class="label">详细地址2</div>
              <div class="text">{{orderForm.shippingDetail.address.address2}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 装箱单信息 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">装箱单信息</span>
        </div>
        <div class="plate-content__main">
          <div class="list-items">
            <div class="item">
              <div class="label">货物类型</div>
              <div class="text">{{orderForm.goodsTypeName}}</div>
            </div>
            <div class="item">
              <div class="label">货物箱数</div>
              <div class="text">{{orderForm.packingList.totalCarton}}</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">预报总重量</div>
              <div class="text">{{toFixed(totalWeight,4)}} kg</div>
            </div>
            <div class="item">
              <div class="label">实测总重量</div>
              <div class="text">{{toFixed(actuallyTotalWeight,4)}} kg</div>
            </div>
          </div>
          <div class="list-items">
            <div class="item">
              <div class="label">预报总体积</div>
              <div class="text">{{toFixed(totalVolume,4)}} cbm</div>
            </div>
            <div class="item">
              <div class="label">实测总体积</div>
              <div class="text">{{toFixed(actuallyTotalVolume,6)}} cbm</div>
            </div>
          </div>
          <el-table :data="orderForm.packingList.cartonDetails" border style="width: 100%; margin-top: 20px;">
            <el-table-column prop="customerCartonNumber" label="客户箱号"></el-table-column>
            <el-table-column prop="cartonNumber" label="系统箱号" width="220"></el-table-column>
            <el-table-column label="预报" align="center">
              <el-table-column prop="length" label="长(cm)"></el-table-column>
              <el-table-column prop="width" label="宽(cm)"></el-table-column>
              <el-table-column prop="height" label="高(cm)"></el-table-column>
              <el-table-column prop="weight" label="毛重(kg)"></el-table-column>
            </el-table-column>
            <el-table-column label="实测" align="center">
              <el-table-column prop="actuallyLength" label="长(cm)"></el-table-column>
              <el-table-column prop="actuallyWidth" label="宽(cm)"></el-table-column>
              <el-table-column prop="actuallyHeight" label="高(cm)"></el-table-column>
              <el-table-column prop="actuallyWeight" label="毛重(kg)"></el-table-column>
            </el-table-column>
            <el-table-column label="SKU" width="200">
              <template slot-scope="scope">
                <p v-for="(d,i) in scope.row.items" :key="i">{{d.sku}}</p>
              </template>
            </el-table-column>
            <el-table-column label="SKU数量">
              <template slot-scope="scope">
                <p v-for="(d,i) in scope.row.items" :key="i">{{d.qty}}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 订单费用 -->
      <div class="plate-content">
        <div class="plate-content__title">
          <span class="title">订单费用</span>
        </div>
        <div class="plate-content__main">
          <el-table :data="costData" class="m-b-20" border style="width: 100%;">
            <el-table-column label="实重">
              <template slot-scope="scope">
                {{toFixed(scope.row.actuallyWeight,3)}}
              </template>
            </el-table-column>
            <el-table-column label="计费重">
              <template slot-scope="scope">
                {{toFixed(scope.row.chargingWeight,3)}}
              </template>
            </el-table-column>
            <el-table-column label="利润" v-if="in_configs(33202)">
              <template slot-scope="scope">
                {{scope.row.costCharge!= null && scope.row.costCharge!="" ? (scope.row.totalAmount - scope.row.costCharge).toFixed(4) : scope.row.totalAmount.toFixed(4)}}
              </template>
            </el-table-column>
            <el-table-column label="成本" v-if="in_configs(33203)">
              <template slot-scope="scope">
                {{scope.row.costCharge!= null && scope.row.costCharge!="" ? scope.row.costCharge : 0}}
              </template>
            </el-table-column>
            <el-table-column prop="totalAmount" label="总费用"></el-table-column>
            <el-table-column width="180" label="费用类型">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.serviceType}}</div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="金额">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.amount}}</div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="币种">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.currency}}</div>
              </template>
            </el-table-column>
            <el-table-column width="200" label="交易时间">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">{{d.txDate}}</div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="明细">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                  <a href="#" title="点击查看明细" @click.prevent="showAllBasicVariables(d.trace)">
                    <i class="el-icon-zoom-in"></i>
                  </a>
                  {{d.trace}}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="120" label="备注">
              <template slot-scope="scope">
                <div v-for="(d, i) in scope.row.items" :key="i" class="trace-item">
                  <el-tooltip v-if="d.remarks && d.remarks !== ''" effect="dark" placement="top">
                    <div slot="content">
                      <div>{{d.remarks}}</div>
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>{{d.remarks}}</span>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 添加进度 -->
    <el-dialog title="添加进度" :visible.sync="dialogCheckVisible3" width="30%">
      <el-form size="small" :model="trackingInfo" label-width="80px">
        <el-form-item label="添加方式">
          <el-radio v-model="addProgressWay" label="single">单个添加</el-radio>
          <el-radio v-model="addProgressWay" label="batch">批量添加</el-radio>
        </el-form-item>
        <el-form-item label="时间" class="require" v-show="addProgressWay == 'single'">
          <el-date-picker v-model="trackingInfo.createAt" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="事件" class="require" v-show="addProgressWay == 'single'">
          <el-input type="text" v-model.trim="trackingInfo.eventName" placeholder="事件"></el-input>
        </el-form-item>
        <el-form-item label="追踪号" v-show="addProgressWay == 'single'">
          <el-input type="text" v-model.trim="trackingInfo.trackingNumber" placeholder="追踪号"></el-input>
        </el-form-item>
        <el-form-item label="描述" class="require" v-show="addProgressWay == 'single'">
          <el-input v-model.trim="trackingInfo.content" type="textarea" placeholder="描述" :autosize="{ minRows: 2}"></el-input>
        </el-form-item>
        <el-form-item label="下载模板" v-show="addProgressWay == 'batch'">
          <a :href="downloadTemp" download="batch_add_track.xlsx" style="display: inline-block; vertical-align: top; color: #3a8ee6;">
            <i class="iconfont icon-xiazai" style="font-size: 12px;"></i> 点击下载模板
          </a>
        </el-form-item>
        <el-form-item label="上传文件" v-show="addProgressWay == 'batch'">
          <el-upload action="#" name="upload" :limit="1" list-type="text" accept=".xlsx,.xls" :on-change="handleTrackChange" :on-remove="handleTrackRemove" :auto-upload="false" :file-list="trackFileList" style="display: inline-block;">
            <el-button slot="trigger" size="small">选取文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible3 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addTrackingInfo()">确 定</el-button>
      </div>
    </el-dialog>
     <!-- 客户端轨迹查询 -->
     <el-dialog title="客户端轨迹查询" :visible.sync="dialogSellerTrackingVisible" width="700px">
      
      <table class="el-table tracking-number__table el-table__body" >
        <thead>
          <tr>                    
            <th width="180">详情</th>            
            <th width="180">时间</th>
            <th width="180">实际时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in trackingList" :key="index">
            <td><div class="cell">{{item.eventName}}</div></td>
            <td><div class="cell">{{item.at}}</div></td>
            <td><div class="cell">{{item.actualAt}}</div></td>
            <td><div class="cell"><el-button size="mini" type="danger" @click="delTracking(item.eventName)" style="margin:10px 10px">删 除</el-button></div></td>
          </tr>
        </tbody>
      </table>
      
    </el-dialog>

    <el-dialog title="查看详情" 
      :visible.sync="showDetailContent" 
      :width="detailTable ? '800px' : '500px'"
      :before-close="hideDetailContent">
			<div v-if="detailTable" style="width: 100%">
				<el-table :data="detialList" tooltip-effect="dark" style="width: 100%">
					<el-table-column prop="cartonNumber" label="系统箱号" width="200"></el-table-column>
					<el-table-column prop="actuallyLength" label="实测长(cm)"></el-table-column>
					<el-table-column prop="actuallyWidth" label="实测宽(cm)"></el-table-column>
					<el-table-column prop="actuallyHeight" label="实测高(cm)"></el-table-column>
					<el-table-column prop="actuallyWeight" label="实测重量(kg)"></el-table-column>
				</el-table>
			</div>
			<div v-if="stringTable" style="width: 100%">
				<el-table :data="detialList" tooltip-effect="dark" style="width: 100%">
					<el-table-column label="跟踪号">
						<template slot-scope="scope">
							<span v-if="manualTrackingNumbers.indexOf(scope.row.split('=')[0])!=-1" style="color:red;">*</span>{{scope.row.split("=")[0]}}
						</template>
					</el-table-column>
					<el-table-column label="箱号">
						<template slot-scope="scope">
							{{scope.row.split("=")[1]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
    <el-dialog title="明细" :visible.sync="dialogShowVariables" append-to-body>
      <p v-if="formulaStr !== ''" v-html="formulaStr"></p>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
// import { getToken } from '@/util/auth'
export default {
  data() {
    return {
      trackingList: [],
      active: 0,
      totalPcs: 0,
      totalQty: 0,
      totalWeight: 0,
      totalVolume: 0,
      actuallyTotalVolume: 0,
      actuallyTotalWeight: 0,
      lastTrackTime: 0,
      fbaChecked: false,
      detailTable: false,
      stringTable: false,
      showDetailContent: false,
      dialogShowVariables: false,
      dialogCheckVisible3: false,
      dialogSellerTrackingVisible: false,
      formulaStr: "",
      addProgressWay: "single",
      downloadTemp: "../../../static/template/batch_add_track.xlsx",
      trackingRecordArray: [],
      trackingNoArray: [],
      batchTrackList: [],
      trackFileList: [],
      costData: [],
      detialList: [],
      trackingInfo: {
        eventName: "",
        content: "",
        trackingNumber: "",
        createAt: "",
        orderId: ""
      },
      orderForm: {
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        },
        taskStages: []
      }
    };
  },
  computed: {
    ...mapState(["manualTrackingNumbers"])
  },
  created() {
    let orderId = this.$route.query.id;
    this.trackingInfo.orderId = orderId;
    setTimeout(() => {
      this.loadData(orderId);
      this.loadCost(orderId);
      this.queryTrackingInfo(orderId);
    }, 100);
  },
  methods: {
    // 查看订单详情，根据ID查询订单
    loadData(id) {
      this.trackingRecordArray = [];
      let _this = this;
      _this.orderForm = {
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        },
        taskStages: []
      };
      _this.active = 0;
      _this.totalPcs = 0;
      _this.totalQty = 0;
      _this.totalWeight = 0;
      _this.totalVolume = 0;
      _this.actuallyTotalWeight = 0;
      _this.actuallyTotalVolume = 0;
      
        this.$request1({
            method: 'post',
            url: '/order/query',
            data: {
              status: "",
              productId: "",
              orderId: [id],
              startDate: "",
              endDate: "",
              currentPage: 1,
              pageSize: 1,
              searchException: this.$route.query.searchException
            }
          })
        .then(function(res) {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              _this.orderForm = res.data.data[0];

              _this.active = 0;
              _this.totalPcs = 0;
              _this.totalQty = 0;
              _this.totalWeight = 0;
              _this.totalVolume = 0;
              _this.actuallyTotalWeight = 0;
              _this.actuallyTotalVolume = 0;
              _this.orderForm.packingList.cartonDetails.forEach((d, i) => {
                _this.totalWeight += d.weight ? d.weight : 0;
                _this.totalVolume +=
                  ((d.length ? d.length : 0) *
                    (d.width ? d.width : 0) *
                    (d.height ? d.height : 0)) /
                  1000000;
                _this.actuallyTotalWeight += d.actuallyWeight
                  ? d.actuallyWeight
                  : 0;
                _this.actuallyTotalVolume +=
                  ((d.actuallyLength ? d.actuallyLength : 0) *
                    (d.actuallyWidth ? d.actuallyWidth : 0) *
                    (d.actuallyHeight ? d.actuallyHeight : 0)) /
                  1000000;
                d.items.forEach((dd, ii) => {
                  _this.totalQty += dd.qty;
                });
              });
              _this.totalPcs = _this.orderForm.packingList.cartonDetails.length;
              if (_this.orderForm.customerRefnumber == null) {
                _this.orderForm.customerRefnumber = {
                  customerOrderNumber: "",
                  fbaNumber: ""
                };
              }
              _this.orderForm.taskStages.forEach((d, i) => {
                if (d.passed) {
                  _this.active = d.stageSeq + 1;
                }
              });

              //算出最后的轨迹时间
              _this.batchTrackList = _this.orderForm.batchTrackDetails;
              _this.batchTrackList
                .sort(function(a, b) {
                  return a.innerTime - b.innerTime;
                })
                .reverse();
              //(d.content != null || d.attach != null) &&
              _this.lastTrackTime = 0;
              _this.orderForm.orderTrack.forEach((d, i) => {
                if (d.eventName.indexOf("批次[") == -1)     
                {
                  _this.trackingRecordArray.unshift(d);
                }

                var date = d.eventAt.replace(/-/g, "/");
                var timestamp = new Date(date).getTime();
                if (timestamp > _this.lastTrackTime) {
                  _this.lastTrackTime = timestamp;
                }
              });
            } else {
              _this.$message.error("Data not found!");
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadCost(orderId) {
      let _this = this;
      _this.costData = [];
      this.$request1({
        method: 'post',
        url: '/order/charge/query',
        withCredentials: true,
        data: {
          orderIds: [orderId],
          startDate: "",
          endDate: "",
          currentPage: 1,
          pageSize: 500,
          export: 0
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            _this.costData = data.data;
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    downloadAttachment(id, detainGoods, searchException) {
      //下载附件
      this.$windowOpen1( '/order/download/attachment' +
          "?orderId=" +
          id +
          "&detainGoods=" +
          detainGoods +
          "&searchException=" +
          searchException
      );
    },
    downloadCustomsDocuments(id) {
      
      this.$windowOpen1(`/order/download/customs?orderId=${id}`);

        // this.$request1({
        //   url: tmsSpringUrl + '/order/download/customs' +"?orderId=" +id,
        //   method: 'get'
        // }).then(res => {
        //   const link = document.createElement('a')
        //   let array = base64ToUint8Array(res.data)
        //   let blob = new Blob([array])
        //   link.style.display = 'none'
        //   link.href = URL.createObjectURL(blob)
        //   let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
        //   link.setAttribute('download', `attachment_${timestr}.xlsx`)
        //   document.body.appendChild(link)
        //   link.click()
        //   document.body.removeChild(link)
        // })
        

    },
    addTrackingInfoPop() {
      this.dialogCheckVisible3 = true;
      this.trackingInfo.eventName = "";
      this.trackingInfo.content = "";
      this.trackingInfo.createAt = "";
      this.trackingInfo.trackingNumber = "";
      this.trackFileList = [];
    },
    //客户端轨迹信息弹框
    sellerTrackingInfoPop(){
      
      let _this =  this;

      this.$request1({
            url: '/order-tracking?orderId=' + this.trackingInfo.orderId,
            method: "get",            
            withCredentials: true
          })
            .then(function(res) {
              if (res.data.success) {
                _this.trackingList = res.data.data;
                _this.dialogSellerTrackingVisible = true;
              } else {
                _this.$message.error(res.data.message);
              }
              
            })
            .catch(function(error) {
              console.log(error);
            });
    },
    // 删除轨迹信息
    delTracking(eventName){
      let _this = this;
      _this
        .$confirm(
          "是否删除客户端【"+eventName+"】轨迹信息？" ,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {

          this.$request1({
            url: '/order-tracking-delete',
            params: {
              orderId: this.trackingInfo.orderId, 
              event: eventName
            },
            method: "post",
            withCredentials: true
          })
            .then(function(res) {
              if (res.data.success) {
                _this.$message.success("Success");
                _this.sellerTrackingInfoPop();
                
              } else {
                _this.$message.error(res.data.message);
              }              
            })
            .catch(function(error) {              
              console.log(error);
            });
        });
    },
    handleTrackChange(file, fileList) {
      this.trackFileList.push(file);
    },
    handleTrackRemove(file, fileList) {
      this.trackFileList = [];
    },
    addTrackingInfo() {
      let _this = this;
      if (this.trackFileList.length == 0) {
        if (
          this.trackingInfo.createAt == null ||
          this.trackingInfo.createAt == ""
        ) {
          _this.$alert("请填写时间。");
          return;
        }
        var date = this.trackingInfo.createAt.replace(/-/g, "/");
        var timestamp = new Date(date).getTime();

        // if (_this.lastTrackTime != 0 && _this.lastTrackTime > timestamp) {
        //   _this.$alert("轨迹时间不能前于前面操作时间。");
        //   return;
        // }
        if (
          this.trackingInfo.eventName == "" ||
          this.trackingInfo.eventName.length > 200
        ) {
          _this.$alert("事件不能为空且事件长度不超过200个字符。");
          return;
        }
        if (this.trackingInfo.content == "") {
          _this.$alert("请填写描述。");
          return;
        }
        if (this.trackingInfo.trackingNumber.length > 60) {
          _this.$alert("追踪号长度不能大于60个字符。");
          return;
        }
      }
      //console.log(this.trackingInfo.createAt);
      _this
        .$confirm(
          "请仔细核对信息，保存后将不能修改,并且同步更新到客户端！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          var formData = new FormData();
          if (this.trackFileList.length > 0) {
            formData.append("file", this.trackFileList[0].raw);
          }
          formData.append("data", JSON.stringify(_this.trackingInfo));
          //轨迹最后的时间
          formData.append("lasttime", _this.lastTrackTime);

          this.$request1({
            url: '/order/tracking-info',
            method: "post",
            data: formData,
            withCredentials: true,
            headers: { "Content-Type": "multipart/form-data" }
          })
            .then(function(res) {
              if (res.data.success) {
                _this.$message.success("Success");
                _this.loadData(_this.trackingInfo.orderId);
              } else {
                _this.$message.error(res.data.message);
              }
              _this.dialogCheckVisible3 = false;
            })
            .catch(function(error) {
              _this.dialogCheckVisible3 = false;
              console.log(error);
            });
        });
    },
    // 查看进度详情
    showDetial(data) {
      let _this = this;
      _this.detialList = data;
      if (typeof data[0] === "string") {
        _this.stringTable = true;
        _this.detailTable = false;
      } else {
        _this.stringTable = false;
        _this.detailTable = true;
      }
      _this.showDetailContent = true;
    },
    hideDetailContent() {
      this.showDetailContent = false;
      this.stringTable = false;
      this.detailTable = false;
    },
    showAllBasicVariables(vars) {
      this.dialogShowVariables = true;
      this.formulaStr = vars.replace(/\n/g, "<br>");
    },
    queryTrackingInfo(orderId) {
      this.$request1({
        method: 'GET',
        url: '/order/query/trackingInfo',
        params: {
          orderId: orderId
        },
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(res => {
          this.trackingNoArray = [];
          if (res.data.success && res.data.data != null) {
            res.data.data.forEach(d => {
              if (d.eventName.includes("[") && d.eventName.endsWith("]")) {
                let eventName = d.eventName.split("[")[0],
                  detail = d.content,
                  eventAt = d.eventAt,
                  warning = d.warning,
                  trackingNo = d.eventName.split("[")[1].slice(0, -1);

                let trackingNoTemp = [];
                this.trackingNoArray.forEach((item, index) => {
                  // 取所有的转单号存到一个数组中
                  trackingNoTemp.push(item.trackingNo);
                });

                if (
                  trackingNoTemp.length === 0 ||
                  !trackingNoTemp.includes(trackingNo)
                ) {
                  // 首次添加
                  this.trackingNoArray.push({
                    trackingNo: trackingNo,
                    collapsed: true,
                    details: [
                      {
                        eventName: eventName,
                        detail: detail,
                        eventAt: eventAt,
                        warning: warning
                      }
                    ]
                  });
                } else {
                  this.trackingNoArray.forEach((item, index) => {
                    if (item.trackingNo === trackingNo) {
                      item.details.push({
                        eventName: eventName,
                        detail: detail,
                        eventAt: eventAt,
                        warning: warning
                      });
                    }
                  });
                }
              }
            });
          }
        })
        .catch(function(error) {});
    }
  }
};
</script>

<style lang="scss" scoped>
.plate-content__main {
  padding: 15px;
}

.step-container {
  margin-top: 15px;
  .step-container__title {
    display: flex;
    align-items: center;
    height: 42px;
    line-height: 42px;
    margin-bottom: 10px;
    border-bottom: 1px dashed #dcdfe6;
    color: #ff9900;
    .el-icon-circle-plus-outline {
      margin-left: 30px;
    }
  }
  .step-container__content {
    > .item {
      display: flex;
      align-items: center;
      color: #606266;
      .time,
      .event,
      .content {
        margin-right: 15px;
      }
      .event {
        font-weight: 600;
        color: #333;
      }
      .warning {
        color: #f56c6c;
      }
      &:not(:last-child) {
        margin-top: 10px;
      }
    }
  }
}

.tracking-record__table {
  .record {
    display: flex;
    align-items: center;
    .detail {
      margin-right: 15px;
    }
    &.warning {
      color: #f56c6c;
    }
  }
}

.tracking-number__table {
  thead tr th,
  tbody tr td {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    &:last-child {
      border-right: 1px solid #ebeef5;
    }
  }
  thead tr th {
    padding: 12px;
  }
  tbody tr {
    td {
      padding: 6px 0;
      vertical-align: top;
      .item {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        &:not(:first-child) {
          color: #99a9bf;
          border-top: 1px dashed #e5e5e5;
        }
        &.warning {
          color: #f56c6c;
        }
      }
    }
    & > :first-child {
      width: 48px;
      text-align: center;
      a {
        transition: all 0.3s;
      }
    }
    & > :first-child,
    & > :nth-child(2) {
      padding: 12px;
    }
  }
}

.download-icon {
  margin-right: 15px;
  color: #409eff;
}

.el-table .cell {
  .trace-item {
    height: 34px;
    line-height: 34px;
    margin: 0 -10px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #ebeef5;
  }
  > .trace-item:first-child {
    margin-top: -10px;
  }
  > .trace-item:last-child {
    border-bottom: none;
    margin-bottom: -10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/checkorder.vue